import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((_nuxtApp) => {
  // Agent inbox module loaded; composables and components are auto-imported.
})
